export const GET_CIRRUSOFT = 'Get Cirrusoft EN';
export const BLOG_READ_MORE = 'Read more';

// Join section
export const JOIN_TITLE = 'Your store. Your setup.';
export const JOIN_SUB_TITLE =
  'Our stellar technical team is here to help you with smooth and seamless transition. Start it easy!';
export const JOIN_BTN = 'Start with Cirrusoft';
